import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressMeter = ({ completionPercentage = 0, completedSections = [], totalSections = 6 }) => {
  const sections = [
    { id: 'basic', label: 'Basic Info', icon: 'User' },
    { id: 'location', label: 'Location', icon: 'MapPin' },
    { id: 'relationship', label: 'Status', icon: 'Heart' },
    { id: 'bio', label: 'Bio', icon: 'FileText' },
    { id: 'interests', label: 'Interests', icon: 'Star' },
    { id: 'photos', label: 'Photos', icon: 'Camera' }
  ];

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 shadow-warm">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-base md:text-lg font-heading font-semibold">Profile Completion</h3>
        <span className="text-2xl md:text-3xl font-heading font-bold text-primary">
          {completionPercentage}%
        </span>
      </div>
      <div className="relative w-full h-3 bg-muted rounded-full overflow-hidden mb-6">
        <div
          className="absolute top-0 left-0 h-full bg-gradient-to-r from-primary to-secondary transition-all duration-500 ease-out"
          style={{ width: `${completionPercentage}%` }}
        />
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
        {sections?.map((section) => {
          const isCompleted = completedSections?.includes(section?.id);
          return (
            <div
              key={section?.id}
              className={`flex flex-col items-center gap-2 p-3 rounded-lg transition-smooth ${
                isCompleted
                  ? 'bg-success/10 text-success' :'bg-muted text-muted-foreground'
              }`}
            >
              <div
                className={`flex items-center justify-center w-10 h-10 rounded-full ${
                  isCompleted ? 'bg-success/20' : 'bg-background'
                }`}
              >
                <Icon
                  name={isCompleted ? 'CheckCircle2' : section?.icon}
                  size={20}
                  color={isCompleted ? 'var(--color-success)' : 'currentColor'}
                />
              </div>
              <span className="text-xs font-caption font-medium text-center">
                {section?.label}
              </span>
            </div>
          );
        })}
      </div>
      {completionPercentage < 100 && (
        <div className="mt-4 p-3 bg-primary/10 rounded-lg flex items-start gap-3">
          <Icon name="Info" size={20} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
          <p className="text-xs md:text-sm text-foreground">
            Complete all sections to maximize your profile visibility and connection opportunities
          </p>
        </div>
      )}
    </div>
  );
};

export default ProgressMeter;